import { IFilterWithValues } from "../../List/components/FilterModal";
import { IFilter } from "../../List/constants/general-filter";

/**
 * Drops every filter whose `filterParam` is not one a tab's catalog offers. A filter saved into
 * the URL (or a link shared before the catalog changed) can name a column the tab's endpoint does
 * not read; the API would either 500 or silently ignore it. Pruning it here keeps the query, the
 * select-all payload and the modal on the same filter.
 *
 * Pure: the input object is never mutated. An undefined filter stays undefined, and one whose
 * entries were all foreign becomes undefined too (not an empty object, which the query builder
 * would still serialise).
 */
export const keepKnownFilters = (
	filter: IFilterWithValues | undefined,
	catalog: IFilter[]
): IFilterWithValues | undefined => {
	if (!filter) {
		return undefined;
	}

	const knownParams = new Set(catalog.map((entry) => entry.filterParam));
	const kept: IFilterWithValues = {};
	let keptAny = false;

	for (const [key, value] of Object.entries(filter)) {
		// The filter comes from `JSON.parse` of a URL param, so an entry can be null or a
		// non-object even though the type says otherwise: drop it rather than crash the tab.
		if (value && typeof value === "object" && knownParams.has(value.filterParam)) {
			kept[key] = value;
			keptAny = true;
		}
	}

	return keptAny ? kept : undefined;
};
